import { Button_default } from "./chunk-GQ3JQOAN.js";
import { renderIcon } from "./chunk-M6GKR2SP.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Thumbnail/Thumbnail.Button.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var ThumbnailButton = forwardRef((_a, ref) => {
  var _b = _a,
    {
      icon = "zoom-plus",
      screenReaderLabel,
      className
    } = _b,
    rest = __objRest(_b, ["icon", "screenReaderLabel", "className"]);
  return /* @__PURE__ */React.createElement(Button_default, __spreadValues({
    ref,
    variant: "white-circle",
    className: clsx("pd-thumbnail__button", className)
  }, rest), /* @__PURE__ */React.createElement("span", {
    className: "pd-sr-only"
  }, screenReaderLabel), renderIcon(icon));
});
var Thumbnail_Button_default = ThumbnailButton;
export { Thumbnail_Button_default };